// extracted by mini-css-extract-plugin
module.exports = {"stroke":"page_stroke__xUC4Z","bounce":"page_bounce__jG_iu"};